import React from 'react';
import { UserRole } from '@/types/user';
import { TogglePill } from '../ui/TogglePill';

type InvestorRoleToggleProps = {
  value: UserRole.INVESTOR_INDIVIDUAL | UserRole.INVESTOR_COMPANY;
  onChange: (role: UserRole.INVESTOR_INDIVIDUAL | UserRole.INVESTOR_COMPANY) => void;
};

export const InvestorRoleToggle: React.FC<InvestorRoleToggleProps> = ({ value, onChange }) => {
  return (
    <div
      style={{
        padding: 4,
        background: 'var(--Light-Grey, #F4F4F4)',
        borderRadius: 30,
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: 4,
        display: 'inline-flex',
      }}
    >
      <TogglePill
        label="Individual"
        isActive={value === UserRole.INVESTOR_INDIVIDUAL}
        onClick={() => onChange(UserRole.INVESTOR_INDIVIDUAL)}
      />
      <TogglePill
        label="Company"
        isActive={value === UserRole.INVESTOR_COMPANY}
        onClick={() => onChange(UserRole.INVESTOR_COMPANY)}
      />
    </div>
  );
};
